import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/shopsite/events/[...slug]/error.tsx");
